module.exports = __webpack_public_path__ + "img/Icon_Estudiante_Transicion.f3d1208d.svg";